import { IncidentHistoryNirvanaDataProvider } from '../dataProvider/IncidentHistoryNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';

export class IncidentHistoryDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, IncidentHistoryNirvanaDataProvider);
  }
}
